import type { ImageStaticContent } from '@core-api/editor/types/response';
import type { Question } from '@mentimeter/legacy-series-types/question';

export const imagePositionToQuestionSlideImageType = (
  imagePosition: ImageStaticContent['imagePosition'] | undefined,
): Question['slide_image_type'] => {
  return imagePosition === 'background' ? 'image-background' : 'image-frame';
};
